import { twMerge } from 'tailwind-merge';
import Skeleton from 'flow/components/ui-components/Skeleton';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectHasTranscriptionCapabilityBusinessOrPersonal } from 'flow/selectors/own-extension-selectors';
import TabsCallRecordDetail, { DetailPageTabKey } from './TabsCallRecordDetail';

export const CallRecordDetailHeaderSkeleton = () => (
    <div className="animate-fade flex h-16 items-center gap-2 px-4 text-gray-200">
        <Skeleton.Icon className="size-6" />
        <div className="flex flex-col gap-1.5">
            <Skeleton.Title className="h-3.5 w-28" />
            <Skeleton.Text className="w-36" />
        </div>
    </div>
);

export const CallRecordDetailContentSkeleton = ({
    initialTab,
    tabsHidden,
    contentClassName,
}: {
    initialTab?: DetailPageTabKey;
    tabsHidden?: DetailPageTabKey[];
    contentClassName?: string;
}) => {
    const hasTranscriptionCapability = useAppSelector(
        selectHasTranscriptionCapabilityBusinessOrPersonal,
    );

    return (
        <div className="animate-fade flex min-h-0 flex-1 flex-col text-gray-200">
            <div
                className={twMerge(
                    'scrollbar-gutter-stable flex justify-center overflow-y-auto ps-4 pe-2',
                    contentClassName,
                )}
            >
                <div className="w-full max-w-[600px]">
                    <TabsCallRecordDetail
                        selectedTab={initialTab ?? 'LOG'}
                        onSelectTab={() => {}}
                        hasTicket={false}
                        tabsHidden={tabsHidden}
                    />
                </div>
            </div>
            <div
                className={twMerge(
                    'scrollbar scrollbar-gutter-stable flex flex-1 justify-center overflow-y-auto ps-4 pe-2',
                    contentClassName,
                )}
            >
                <div className="flex w-full max-w-[600px] flex-col gap-3">
                    <div className="flex w-full items-center gap-2 px-4 pt-3">
                        <Skeleton.Line />
                        <Skeleton.Text className="h-4 w-20 shrink-0" />
                        <Skeleton.Line />
                    </div>

                    <div className="flex flex-col gap-1">
                        <div className="flex h-5 items-center gap-2 px-3">
                            <div className="flex flex-1 items-center gap-2">
                                <Skeleton.Title className="h-3 w-28" />
                                <Skeleton.Text className="w-20" />
                            </div>
                            <Skeleton.Text className="w-10" />
                        </div>

                        <div className="bg-gray-150 flex items-center gap-1 rounded p-3">
                            <Skeleton.Title className="h-10 flex-1 rounded" />
                            {hasTranscriptionCapability && (
                                <Skeleton.Title className="h-10 w-24 rounded" />
                            )}
                            <Skeleton.Icon className="size-10 rounded" />
                        </div>

                        {hasTranscriptionCapability && (
                            <div className="bg-gray-150 flex flex-col gap-3 rounded p-3">
                                <div className="flex flex-col gap-2">
                                    <Skeleton.Title className="h-3 w-16" />
                                    <Skeleton.Text className="w-full" />
                                    <Skeleton.Text className="w-3/4" />
                                </div>
                            </div>
                        )}

                        <div className="bg-gray-150 flex flex-col gap-3 rounded p-3">
                            <Skeleton.Title className="h-3 w-16" />
                            <div className="flex flex-col gap-2">
                                <Skeleton.Text className="w-32" />
                                <Skeleton.Text className="w-24" />
                                <Skeleton.Text className="w-40" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
